import {AutoEncoder, field, StringDecoder} from '@simonbackx/simple-encoding'

export class TouchSystemsLogin extends AutoEncoder {
    @field({decoder: StringDecoder})
    APIKey: string
}
